export function useColorClass(name) {
  return {
    bg: `bg-[var(--color-${name})]`,
    text: `text-[var(--color-${name})]`,
    border: `border-[var(--color-${name})]`,
  };
}
